<script lang="ts">
  import { scale } from "svelte/transition";
  import SafeHtml, {type MaybeHtml} from "./SafeHtml.svelte";

  let {
    type: railsType = "notice",
    message,
    shadow = false,
    autohide = null,
  } : {
    type : string,
    message : MaybeHtml,
    shadow : boolean,
    autohide : number | false | null,
  } = $props()

  let type = {
    alert: "warning",
    notice: "info"
  }[railsType] || railsType

  // Default autohide for type="success" in the absence of an explicit prop value
  if(autohide === null) autohide = (type == "success") && 5_000

  let dismissed = $state(true)
  const dismiss = ()=>dismissed = true;

  $effect(()=>{
    // Transition in 0.2s after mounting
    setTimeout(()=>dismissed = false, 200)
    if(autohide) {
      let timeout = setTimeout(dismiss, autohide)
      return ()=>clearTimeout(timeout)
    }
  });
</script>
{#if !dismissed}
  <div
    class="alert flex gap-0 justify-between rounded-lg pl-4 pr-2 py-3 w-max max-w-[min(24rem,97vw)]"
    class:alert-error={type == "error"}
    class:alert-warning={type == "warning"}
    class:alert-success={type == "success"}
    class:alert-info={type == "info"}
    class:shadow-md={shadow}
    transition:scale={{duration: 150, start: 0.75}}
  >
    {#if type == "error"}
      <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current hidden sm:inline-block shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    {:else if type == "warning"}
      <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current hidden sm:inline-block shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
    {:else if type == "success"}
      <svg xmlns="http://www.w3.org/2000/svg" class="stroke-none fill-current inline-block shrink-0 h-6 w-6" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z"></path></svg>
    {:else if type == "info"}
      <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current hidden sm:inline-block shrink-0 w-6 h-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
    {/if}
    <span class="grow text-base text-left text-wrap ml-4"><SafeHtml value={message} /></span>
    <button
      type="button"
      class="btn btn-sm btn-circle btn-ghost ml-1"
      aria-label="Dismiss"
      onclick={dismiss}
    >✕</button>
  </div>
{/if}
